export const NAV_LINKS = [
  { label: "Hem", href: "#hem", id: "hem", testId: "nav-link-hem" },
  { label: "Tjänster", href: "#tjanster", id: "tjanster", testId: "nav-link-tjanster" },
  { label: "Paket", href: "#paket", id: "paket", testId: "nav-link-paket" },
  { label: "Priser", href: "#priser", id: "priser", testId: "nav-link-priser" },
  { label: "Om oss", href: "#om-oss", id: "om-oss", testId: "nav-link-om-oss" },
  { label: "Kontakt", href: "#kontakt", id: "kontakt", testId: "nav-link-kontakt" },
];

export const SERVICES = [
  {
    title: "Hemsidor",
    description:
      "Moderna, professionella och mobilanpassade hemsidor som ger ditt företag ett starkt första intryck och gör det enkelt för kunder att hitta och kontakta dig.",
    price: "6 999 kr + 349 kr/mån",
    icon: "Monitor",
    testId: "service-card-hemsidor",
  },
  {
    title: "Logotyp & grafisk design",
    description:
      "Professionella logotyper och grafiskt material som hjälper ditt företag att skapa en tydlig och genomtänkt visuell identitet.",
    price: "399 kr",
    icon: "PenTool",
    testId: "service-card-logotyp",
  },
  {
    title: "Menydesign",
    description: "Moderna och lättlästa menyer för restauranger, caféer och andra verksamheter.",
    price: "1 199 kr",
    icon: "UtensilsCrossed",
    testId: "service-card-menydesign",
  },
  {
    title: "Reklamblad & flyers",
    description:
      "Professionellt designade reklamblad och flyers för kampanjer, erbjudanden, evenemang och marknadsföring.",
    price: "599 kr",
    icon: "FileText",
    testId: "service-card-flyers",
  },
  {
    title: "Posters & affischer",
    description: "Visuellt tydliga posters och affischer som fångar uppmärksamhet och kommunicerar ditt budskap.",
    price: "599 kr",
    icon: "Image",
    testId: "service-card-posters",
  },
  {
    title: "Google Företagsprofil",
    description:
      "Vi hjälper dig att förbättra hur ditt företag presenteras på Google genom bättre information, bilder och visuellt innehåll.",
    price: "129 kr",
    icon: "MapPin",
    testId: "service-card-google",
  },
  {
    title: "Sociala medier",
    description:
      "Vi hjälper ditt företag att synas professionellt på Instagram och Facebook. Vi skapar innehåll som stärker ditt varumärke, engagerar din målgrupp och bygger relationer med dina kunder.",
    price: "299 kr + 149 kr/mån",
    icon: "Share2",
    testId: "service-card-sociala",
  },
  {
    title: "Digital annonsering",
    description:
      "Vi hjälper till att skapa och sätta upp digitala annonseringskampanjer för att nå potentiella kunder.",
    price: "799 kr + 249 kr/mån",
    icon: "Megaphone",
    testId: "service-card-annonsering",
  },
];

export const WHY_POINTS = [
  {
    title: "Allt på ett ställe",
    description: "Webb, design, sociala medier och digital marknadsföring – samlat hos samma partner.",
    icon: "Layers",
    testId: "why-point-allt",
  },
  {
    title: "Personligt",
    description: "Vi arbetar nära våra kunder och anpassar lösningarna efter verksamhetens behov.",
    icon: "HeartHandshake",
    testId: "why-point-personligt",
  },
  {
    title: "Professionellt",
    description: "Vi fokuserar på en modern och genomtänkt digital presentation.",
    icon: "BadgeCheck",
    testId: "why-point-professionellt",
  },
  {
    title: "Enkelt",
    description: "Digital utveckling ska inte behöva vara komplicerad.",
    icon: "Smile",
    testId: "why-point-enkelt",
  },
  {
    title: "Prisvärt",
    description: "Vi erbjuder tydliga lösningar som passar små och växande företag.",
    icon: "PiggyBank",
    testId: "why-point-prisvart",
  },
];

export const PROCESS_STEPS = [
  {
    step: "01",
    title: "Du berättar",
    description: "Du berättar om ditt företag och vad du behöver hjälp med.",
    testId: "process-step-1",
  },
  {
    step: "02",
    title: "Vi planerar",
    description: "Vi går igenom behov, mål och lämplig lösning.",
    testId: "process-step-2",
  },
  {
    step: "03",
    title: "Vi skapar",
    description: "Tillvia tar fram design, webbplats eller digitalt material.",
    testId: "process-step-3",
  },
  {
    step: "04",
    title: "Du lanserar",
    description: "När allt är klart hjälper vi till att få lösningen på plats.",
    testId: "process-step-4",
  },
];

export const PACKAGES = [
  {
    id: "start",
    name: "Tillvia Start",
    tagline: "För företag som vill komma igång online.",
    oneTime: "6 499 kr",
    monthly: "349 kr/mån",
    features: ["Hemsida", "Google Företagsprofil"],
    popular: false,
    testId: "package-start",
  },
  {
    id: "business",
    name: "Tillvia Business",
    tagline: "För företag som vill ha en professionell digital grund.",
    oneTime: "6 899 kr",
    monthly: "349 kr/mån",
    features: ["Hemsida", "Google Företagsprofil", "Logotyp"],
    popular: true,
    testId: "package-business",
  },
  {
    id: "growth",
    name: "Tillvia Growth",
    tagline: "För företag som vill växa med en komplett digital grund.",
    oneTime: "7 799 kr",
    monthly: "349 kr/mån",
    features: ["Hemsida", "Google Företagsprofil", "Logotyp", "Menydesign"],
    popular: false,
    testId: "package-growth",
  },
  {
    id: "social",
    name: "Tillvia Social",
    tagline: "För företag som vill stärka sin närvaro på sociala medier.",
    oneTime: "8 499 kr",
    monthly: "498 kr/mån",
    features: ["Hemsida", "Google Företagsprofil", "Logotyp", "Menydesign", "Sociala medier", "Affisch"],
    popular: false,
    testId: "package-social",
  },
  {
    id: "brand",
    name: "Tillvia Brand",
    tagline: "För företag som behöver en tydlig visuell identitet.",
    oneTime: "2 199 kr",
    monthly: null,
    features: ["Logotyp", "Menydesign", "Reklamblad", "Affisch"],
    popular: false,
    testId: "package-brand",
  },
  {
    id: "local",
    name: "Tillvia Local",
    tagline: "För lokala företag som vill synas bättre.",
    oneTime: "799 kr",
    monthly: "149 kr/mån",
    features: ["Sociala medier", "Google Företagsprofil", "Affisch"],
    popular: false,
    testId: "package-local",
  },
  {
    id: "complete",
    name: "Tillvia Complete",
    tagline: "En komplett digital lösning.",
    oneTime: "8 999 kr",
    monthly: "747 kr/mån",
    features: [
      "Hemsida",
      "Google Företagsprofil",
      "Logotyp",
      "Menydesign",
      "Reklamblad",
      "Affisch",
      "Sociala medier",
      "Digital annonsering",
    ],
    popular: false,
    wide: true,
    testId: "package-complete",
  },
];

export const PRICE_LIST = [
  { name: "Hemsida", price: "6 999 kr + 349 kr/mån" },
  { name: "Logotyp & grafisk design", price: "399 kr" },
  { name: "Menydesign", price: "1 199 kr" },
  { name: "Reklamblad", price: "599 kr" },
  { name: "Affischer", price: "599 kr" },
  { name: "Google Företagsprofil", price: "129 kr" },
  { name: "Sociala medier", price: "299 kr + 149 kr/mån" },
  { name: "Digital annonsering", price: "799 kr + 249 kr/mån" },
];

export const SUBSCRIPTIONS = [
  {
    title: "Hemsida",
    price: "349 kr/mån",
    features: [
      "Webbhotell och drift",
      "Säkerhetsuppdateringar och tekniskt underhåll",
      "Mindre ändringar av text, bilder och kontaktuppgifter",
      "Löpande support",
    ],
    testId: "subscription-hemsida",
  },
  {
    title: "Sociala medier",
    price: "149 kr/mån",
    features: [
      "Planering och publicering på Instagram och Facebook",
      "Texter och enklare grafik till inlägg",
      "Anpassning efter kundens varumärke",
      "Löpande uppföljning",
    ],
    testId: "subscription-sociala",
  },
  {
    title: "Digital annonsering",
    price: "249 kr/mån",
    features: [
      "Hantering av annonser på Instagram och Facebook",
      "Anpassning av målgrupp, budget och annonsinnehåll",
      "Löpande optimering",
      "Enkel resultatuppföljning",
    ],
    testId: "subscription-annonsering",
  },
];

export const SUBSCRIPTION_NOTE =
  "Alla priser är inklusive design och kan anpassas efter projektets omfattning. Annonsbudget för digital annonsering tillkommer och betalas direkt av kunden.";

export const SERVICE_OPTIONS = [
  "Hemsida",
  "Logotyp",
  "Grafisk design",
  "Menydesign",
  "Reklamblad / flyer",
  "Poster / affisch",
  "Google Företagsprofil",
  "Facebook / Instagram",
  "Digital annonsering",
  "Flera av ovanstående",
  "Annat",
];

export const BUDGET_OPTIONS = [
  "Under 5 000 kr",
  "5 000–10 000 kr",
  "10 000–20 000 kr",
  "20 000 kr eller mer",
  "Vet inte ännu",
];

export const MEETING_FORMATS = ["Videomöte", "Telefonsamtal", "Fysiskt möte"];

export const CONTACT_EMAIL = "info@tillvia.se";
export const CONTACT_PHONE = "072-441 66 71";
export const CONTACT_PHONE_TEL = "+46724416671";
